import { httpClient } from "infra/axios/axios-api";
import { Employee } from "domain/entities/employee";
import { TimesheetReport } from "domain/entities/timesheet-report";

/**
 * Parâmetros para a função de upload do blob do PDF.
 */
interface UploadBlobParams {
  blob: Blob;
  report: TimesheetReport;
  employee: Employee;
}

/**
 * Função de serviço que recebe um blob de PDF, faz o upload para o armazenamento
 * e retorna o caminho do ficheiro guardado.
 *
 * @param {UploadBlobParams} params - Os parâmetros necessários para o upload.
 * @returns {Promise<string>} Uma promessa que resolve com o caminho do ficheiro (s3Path).
 */
export const uploadTimesheetPdfBlob = async ({
  blob,
  report,
  employee,
}: UploadBlobParams): Promise<string> => {
  const formData = new FormData();
  const monthYear = String(report.month).padStart(2, "0") + "-" + report.year;
  const fileName = `${monthYear}-timesheet.pdf`;
  formData.append("file", blob, fileName);

  const folder = `timesheets/${monthYear}/${employee?.id}`;
  const uploadResponse = await httpClient.post(
    `/assets/${folder}`,
    formData
  );
  return uploadResponse.data.filePath;
};
